import { Link as LinkLi } from '@material-ui/core';
import EditSharpIcon from '@material-ui/icons/EditSharp';
import HistoryIcon from '@material-ui/icons/History';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SvgIcon from 'globalcomponents/SvgIcon/Base';
import { pageUrls, ROLES } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { UI_LOGBOOK_DATE } from 'globalconfig/constants/static';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import moment from 'moment';
import React, { lazy, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));

export default function useOptions({ setIsToolsClicked, parentProps, setSelectedIndexfn }) {
  const { i18n } = useTranslation();

  const actions = useMemo(() => {
    const actionConfig = {
      empty: [],
      spireon_type: [
        {
          icon: (row) => (
            <LinkLi
              component={Link}
              to={
                hasRestrictedRole([ROLES.VIEW_ONLY_FM])
                  ? pageUrls.signedLogsView.replace(':id', row.idPub)
                  : pageUrls.logsEdit.replace(':id', row.idPub)
              }
              onClick={(e) => e.stopPropagation()}
            >
              {hasRestrictedRole([ROLES.VIEW_ONLY_FM]) ? (
                <VisibilityIcon className="historyIcon" />
              ) : (
                <EditSharpIcon className="historyIcon" />
              )}
            </LinkLi>
          ),
        },
        {
          icon: (row) => {
            const day = moment(row.date).format(UI_LOGBOOK_DATE);
            return (
              <LinkLi
                component={Link}
                to={`${pageUrls.logBook.replace(':id', row.idPub)}?driverId=${row.driverId}&logDay=${day}`}
                onClick={(e) => e.stopPropagation()}
              >
                <SvgIcon value={mediaUrls.bookSolid} className="logbookIcon" />
              </LinkLi>
            );
          },
        },
        {
          icon: (row) => (
            <LinkLi component={Link} to={pageUrls.logsHistory.replace(':id', row.idPub)} onClick={(e) => e.stopPropagation()}>
              <HistoryIcon className="historyIcon" />
            </LinkLi>
          ),
        },
      ],
      non_clutch: [
        {
          icon: (row, index) => (
            <Icon
              src={mediaUrls?.toolsIcon}
              onClick={() => {
                setIsToolsClicked(true);
                parentProps.setSelectedManageLogItem({ index, row });
                setSelectedIndexfn(index);
              }}
            />
          ),
        },
      ],
      default: [
        {
          icon: (row) => (
            <LinkLi component={Link} to={pageUrls.logsEdit.replace(':id', row.idPub)} onClick={(e) => e.stopPropagation()}>
              <Icon src={mediaUrls?.edit} tooltip={i18n.t('Edit')} />
            </LinkLi>
          ),
        },
        {
          icon: (row) => (
            <LinkLi component={Link} to={pageUrls.logsHistory.replace(':id', row.idPub)} onClick={(e) => e.stopPropagation()}>
              <Icon src={mediaUrls?.logHistory} id="logsHistory" tooltip={i18n.t('History')} />
            </LinkLi>
          ),
        },
      ],
    };

    const mapping = [
      { condition: hasRestrictedRole(['ADMIN']), key: 'empty' },
      { condition: layout === 'SpireonNew', key: 'spireon_type' },
      { condition: layout !== 'Clutch', key: 'non_clutch' },
      { condition: true, key: 'default' },
    ];

    const matched = mapping.find((x) => x.condition);
    return actionConfig[matched.key] || [];
  }, [setIsToolsClicked, parentProps, setSelectedIndexfn, i18n.language]);

  return { actions };
}
